<article *ngIf="item" class="asset-item-basic" tabindex="0">
  <figure *ngIf="!editFlag" class="asset-preview">
    <img *ngIf="item.previewUrl; else fallbackImage" [src]="item.previewUrl" [alt]="item.name" class="asset-image" />
    <ng-template #fallbackImage>
      <mat-icon *ngIf="item.assetType | assetTypeToIconName; else defaultIcon" class="material-icons-outlined asset-icon">{{ item.assetType | assetTypeToIconName }}</mat-icon>

      <ng-template #defaultIcon>
        <mat-icon class="material-icons-outlined asset-icon">block</mat-icon>
      </ng-template>
    </ng-template>

    <div *ngIf="item.isProcessing" class="loading-spinner-container">
      <mat-progress-spinner [mode]="'indeterminate'" [diameter]="50" class="loading-spinner"></mat-progress-spinner>
    </div>
  </figure>

  <figure *ngIf="editFlag" class="asset-preview">
    <img *ngIf="item.imageUrl" class="asset-image" [src]="item.imageUrl | imageLoading | async" [alt]="item.name" />
    <ng-template #fallbackImage>
      <mat-icon *ngIf="item.assetType | assetTypeToIconName; else defaultIcon" class="material-icons-outlined asset-icon">{{ item.assetType | assetTypeToIconName }}</mat-icon>
      <ng-template #defaultIcon>
        <mat-icon class="material-icons-outlined asset-icon">block</mat-icon>
      </ng-template>
    </ng-template>
  </figure>

  <div class="asset-name">
    <span [matTooltip]="item.name">{{ item.name }}</span>
  </div>

  <div class="asset-type">
    <span>{{ item.assetType | assetTypeTranslation }}</span>
  </div>

  <div class="asset-actions">
    <ng-content select="[assetActionsSlot]"></ng-content>
  </div>
</article>
